import { MessageCircle } from "lucide-react";

const SMS_LINK =
  "sms:+12109204677?&body=Hi%20Shaken%20Society!%20I%27d%20like%20to%20know%20more%20about%20your%20mobile%20bar%20service.";

export default function TextButton() {
  return (
    <a
      href={SMS_LINK}
      data-testid="floating-text-button"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-gold px-6 py-3.5 text-sm font-semibold uppercase tracking-[0.14em] text-espresso shadow-[0_16px_36px_-12px_rgba(29,19,12,0.7)] transition-transform duration-300 hover:scale-105 md:hidden"
    >
      <MessageCircle className="h-4 w-4" />
      Text us
    </a>
  );
}